import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

type ListMerchantGroupsMerchant = {
  id: number
  name: string
}

export type ListMerchantGroupsItem = {
  id: string
  name: string
  merchants: Array<ListMerchantGroupsMerchant>
}

type ListMerchantGroupsResponse = Paginate<
  Array<ListMerchantGroupsItem>
>

export type ListMerchantGroupsFilter = {
  search?: string
}
type ListMerchantGroupsQuery = Pagination &
  ListMerchantGroupsFilter

const listMerchantGroups = async (
  query: ListMerchantGroupsQuery
) => {
  const { body } =
    await api.get<ListMerchantGroupsResponse>(
      "/merchant-groups/",
      {
        query,
      }
    )

  return body
}

export const MERCHANT_GROUPS_QUERY_KEY = "merchantGroups"

export const useMerchantGroups = (
  query: MaybeRef<ListMerchantGroupsQuery>
) =>
  useQuery({
    queryKey: [MERCHANT_GROUPS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, _query] }) =>
      listMerchantGroups(_query),
    keepPreviousData: true,
  })
